document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    document.querySelectorAll('.tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
            const tabId = tab.dataset.id;

            tab.classList.add('active');
            Array.from(tab.parentElement.children).forEach(function (sibling) {
                if (sibling !== tab) {
                    sibling.classList.remove('active');
                }
            });

            document.querySelectorAll('.tab-content').forEach(function (content, i) {
                content.classList.remove('active');
                content.classList.add('inactive');
                content.classList.add('tab-content-' + (i + 1));
            });

            document.querySelectorAll('.tab-content-' + tabId).forEach(function (content) {
                content.classList.remove('inactive');
                content.classList.add('active');
            });
        });
    });
});
